import { Observable, of } from 'rxjs/index';
import Event from '../../core/Event';
import { ofType, StateObservable } from 'redux-observable';
import api from '../../core/api';
import { catchError, map, mergeMap } from 'rxjs/internal/operators';
import { AjaxError, AjaxResponse } from 'rxjs/internal/observable/dom/AjaxObservable';
import RequestFailed from '../../core/events/RequestFailed';
import State from 'src/application/core/State';
import UserEstimationRequested from '../events/UserEstimationRequested';
import UserEstimationGetSucceed from '../events/UserEstimationGetSucceed';
import { AjaxBackend } from '../../testHelpers/fakeBackendFactory';

export default (event$: Observable<Event>, state$: StateObservable<State>, backend: AjaxBackend): Observable<Event> =>
    event$.pipe(
        ofType(UserEstimationRequested.type),
        mergeMap((event: UserEstimationRequested) => {
            return backend.get(`${api()}users/${event.customerId}/estimations/${event.estimationId}/details`).pipe(
                map((ajaxResponse: AjaxResponse) => new UserEstimationGetSucceed(ajaxResponse.response)),
                catchError((e: AjaxError) => of(new RequestFailed(e.status)))
            );
        })
    );



// WEBPACK FOOTER //
// ./src/application/estimations/epic/estimationDetailsGet.ts